module.exports = __webpack_public_path__ + "./images/5677fcd8b2ec03fa26461afdab55eae7.webp";